import React from "react";
import { motion } from "framer-motion";

const CoreStrengthCards = () => {
  const strengths = [
    {
      number: "#01",
      title: "Professional Training",
      description:
        "Comprehensive curriculum designed by industry experts to prepare you for real-world aviation challenges.",
    },
    {
      number: "#02",
      title: "Certified Instructors",
      description:
        "Learn from experienced pilots with thousands of flight hours and proven teaching excellence.",
    },
    {
      number: "#03",
      title: "Modern Fleet",
      description:
        "Train on well-maintained, state-of-the-art aircraft equipped with the latest avionics technology.",
    },
    {
      number: "#04",
      title: "Safety First",
      description:
        "Uncompromising commitment to safety with rigorous maintenance and comprehensive pre-flight procedures.",
    },
  ];

  // Animation variants
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2, // small delay between cards
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <section className="relative w-full py-20 bg-gray-50">
      <motion.div
        className="container mx-auto px-6"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {strengths.map((item, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 flex flex-col"
              variants={cardVariants}
            >
              <span className="text-[#012D6F] text-4xl font-bold mb-2">
                {item.number}
              </span>
              <h3 className="text-[#E43038] text-xl font-semibold mb-2">
                {item.title}
              </h3>
              <p className="text-gray-700 text-sm">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default CoreStrengthCards;
